module.exports = __webpack_public_path__ + "static/media/projects.13e48fa6.svg";